import { Link } from '@reach/router';
import React, { useContext, useEffect, useState } from 'react';
import GroupInfo from '../../../../components/settings/group/GroupInfo';
import GroupSubjects from '../../../../components/settings/group/GroupSubjects';
import GroupTrackers from '../../../../components/settings/group/GroupTrackers';
import { Group } from '../../../../components/settings/group/types';
import GroupMemberList from '../../../../components/settings/group/GroupMemberList';
import { ButtonFilled } from '../../../../components/ui';
import { AccountContext } from '../../../../context/account';
import client from '../../../../lib/client';
import {
  GroupMembersQuery,
  GroupMembersQueryVariables
} from '../../../../queries/__generated__/GroupMembersQuery';
import { groupMembersQuery } from '../../../../queries/groups';
import { UserContext } from '../../../../context/UserContext';

interface GroupsSettingsProps {
  group: Group;
}

const GroupSettings: React.FC<GroupsSettingsProps> = ({ group }) => {
  const accountContext = useContext(AccountContext);
  const { user } = useContext(UserContext);
  const [canEdit, setCanEdit] = useState(false);

  useEffect(() => {
    async function fetchGroupMembers() {
      const groupMembersResult = await client.query<GroupMembersQuery, GroupMembersQueryVariables>({
        query: groupMembersQuery,
        variables: {
          input: {
            groupId: group.id
          }
        }
      });

      const foundMember = groupMembersResult.data.groupMembers.find(
        gm => gm.member.id === user.memberIdForAccount(accountContext.selectedAccountId)
      );

      if (foundMember && foundMember.roleType.toUpperCase() === 'ADMIN') {
        console.log('setting edit to true');
        setCanEdit(true);
      }
    }

    fetchGroupMembers();
  }, []);

  return (
    <>
      <GroupInfo group={group} isUserGroupOwner={canEdit} />
      <GroupMemberList group={group} />
      <GroupTrackers group={group} userCanAdmin={canEdit} />
      <GroupSubjects group={group} isUserGroupOwner={canEdit} />

      {canEdit && (
        <Link to={`/notebook/group/${group.id}/delete`} data-testid="delete-button">
          <ButtonFilled>Delete Group</ButtonFilled>
        </Link>
      )}
    </>
  );
};

export default GroupSettings;
